import {
  ADMIN_YT_AUDITS_LOADED,
  ADMIN_YT_AUDIT_DETAIL_LOADED,
  ADMIN_YT_AUDIT_DETAIL_CLEAR,
  ADMIN_YT_AUDIT_USERS_LOADED,
  ADMIN_YT_AUDITS_CLEAR,
} from '../../actions/actionTypes';

const initialState = {
  audits: null,
  total: 0,
  detail: null,
  adminUsers: null,
};

function adminYtAudits(state = initialState, action) {
  switch (action.type) {
    case ADMIN_YT_AUDITS_LOADED:
      return { ...state, audits: action.payload.audits, total: action.payload.total };
    case ADMIN_YT_AUDIT_DETAIL_LOADED:
      return { ...state, detail: action.payload.audit };
    case ADMIN_YT_AUDIT_DETAIL_CLEAR:
      return { ...state, detail: null };
    case ADMIN_YT_AUDIT_USERS_LOADED:
      return { ...state, adminUsers: action.payload.users };
    case ADMIN_YT_AUDITS_CLEAR:
      return initialState;
    default:
      return state;
  }
}

export default adminYtAudits;
